module.exports = __webpack_public_path__ + "static/media/hand alt.20dd76ee.png";